<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.confirmCookieSettings}}</h3>
</div>
<div id="cookiesManageContainer" class="modal-body" style="max-height: 838px;">
    <form id="userCookiesForm">
        <h4><i class="fa fa-lock" aria-hidden="true"></i> Essential</h4>
        <div class="row-fluid well-small span12">
            <p>We use essential cookies to make our site work for you.</p>
            <p>Our product uses the following Session cookies. These are temporary cookies that expire (and are automatically erased) whenever you close your browser.</p>
            <ul>
                <li>To track the session expiry time. Required in order to end the user session after a period of inactivity.</li>
                <li>To  store the offset (if any) between the  server and the client time. Required in order to accurately monitor the session inactivity.</li>
                <li>To store the session ID. Identifies the user who has logged on to the website in order to assign the appropriate application preferences and security privileges <br>as well as to audit user activity.</li>
            </ul>
        </div>
        <h4>
	        <label style="display:inline;" class="control control--checkbox">
	            <input type="checkbox" [(ngModel)]="gaCookieAllowed" name="gacookies" aria-label="Enable Google Analytics" title="Enable Google Analytics">
	            <div class="control__indicator"></div>
	        </label> Google Analytics
        </h4>
        <div class="row-fluid well-small span12">
            <p>We use Google Analytics cookies to improve our application by collecting and reporting information on how you use it. The cookies generate user statistics but do not directly identify users.</p>
        </div>
    </form>
    <p>To find out more about cookies, please refer to our <a href="~/../app/misc/PTFS Cookie Policy.pdf" target="_blank"> Cookie Policy</a>.</p>

</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="save()">{{LOCALIZATION.save}}</button>
</div>
